import * as React from 'react';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { adminlogout } from '../services/AuthenticationService';
import config from "../configurations/config";


export default function PopoverPopup(props) {
    const logout = () => {
        sessionStorage.clear();
        window.location.href = config.auth.URL+"logout";
      };
    
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <>
      <div  {...bindTrigger(popupState)} className="options-button icon-button account-button" type="button">
      <div className="options-button__content">
          <svg fill="inherit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
          <path fill="none" stroke={`${popupState.isOpen ? '#00787a' : 'inherit'}`} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M25 3.007999999999999A22 22 0 1 0 25 47.007999999999996A22 22 0 1 0 25 3.007999999999999Z"></path>
          <path fill={`${popupState.isOpen ? '#00787a' : 'inherit'}`} d="M25,48.008c-9.308,0-15.451-6.044-15.708-6.302C9.097,41.511,8.991,41.243,9,40.966s0.133-0.537,0.341-0.719c1.681-1.471,3.954-2.273,5.959-2.981c2.094-0.739,4.076-1.439,4.624-2.645c0.086-1.031,0.079-1.835,0.071-2.76l-0.002-0.381c-0.889-0.845-2.005-2.627-2.387-4.276c-0.66-0.352-1.465-1.196-1.708-3.217c-0.123-1.023,0.176-1.812,0.589-2.333c-1.116-4.658-0.779-8.208,1.004-10.558C19.003,9.105,21.495,8.063,24.896,8c2.238,0,3.913,0.599,4.8,1.697c1.579,0.319,2.78,1.128,3.576,2.409c1.882,3.031,0.808,7.726,0.268,9.581c0.4,0.521,0.684,1.298,0.563,2.301c-0.242,2.021-1.048,2.865-1.708,3.217c-0.382,1.647-1.499,3.43-2.387,4.275l-0.002,0.391c-0.008,0.921-0.016,1.723,0.07,2.75c0.546,1.203,2.518,1.895,4.602,2.625c2.018,0.708,4.305,1.51,5.987,3.005c0.206,0.183,0.327,0.442,0.335,0.718c0.008,0.275-0.097,0.542-0.292,0.736C40.451,41.964,34.308,48.008,25,48.008z"></path>
        </svg>
        </div></div>
         <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
              <button onMouseDown={()=>{logout()}} className='default-button signout-button'>Sign Out</button>
          </Popover>
        </>
      )}
    </PopupState>
  );
}
